var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _circle, _path13, _circle2, _circle3, _circle4, _polygon, _path14, _path15, _clipPath, _g2, _circle5, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _circle6, _path16, _path17, _clipPath2, _g3, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "list",
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70889 1C6.70889 0.447715 7.15661 0 7.70889 0H18.2501C18.8024 0 19.2501 0.447715 19.2501 1C19.2501 1.55228 18.8024 2 18.2501 2H7.70889C7.15661 2 6.70889 1.55228 6.70889 1Z",
    fill: "#ADADB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70889 6.74999C6.70889 6.1977 7.15661 5.74999 7.70889 5.74999H18.2501C18.8024 5.74999 19.2501 6.1977 19.2501 6.74999C19.2501 7.30227 18.8024 7.74999 18.2501 7.74999H7.70889C7.15661 7.74999 6.70889 7.30227 6.70889 6.74999Z",
    fill: "#ADADB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70889 12.5C6.70889 11.9477 7.15661 11.5 7.70889 11.5H18.2501C18.8024 11.5 19.2501 11.9477 19.2501 12.5C19.2501 13.0523 18.8024 13.5 18.2501 13.5H7.70889C7.15661 13.5 6.70889 13.0523 6.70889 12.5Z",
    fill: "#ADADB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H1.95879C2.51108 0 2.95879 0.447715 2.95879 1C2.95879 1.55228 2.51108 2 1.95879 2H1C0.447715 2 0 1.55228 0 1Z",
    fill: "#ADADB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.74999C0 6.1977 0.447715 5.74999 1 5.74999H1.95879C2.51108 5.74999 2.95879 6.1977 2.95879 6.74999C2.95879 7.30227 2.51108 7.74999 1.95879 7.74999H1C0.447715 7.74999 0 7.30227 0 6.74999Z",
    fill: "#ADADB4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 11.9477 0.447715 11.5 1 11.5H1.95879C2.51108 11.5 2.95879 11.9477 2.95879 12.5C2.95879 13.0523 2.51108 13.5 1.95879 13.5H1C0.447715 13.5 0 13.0523 0 12.5Z",
    fill: "#ADADB4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "touchpad",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41836 10.4144C7.41836 9.95496 7.04504 9.57207 6.57601 9.57207H0.83277C0.373311 9.57207 0 9.94538 0 10.4144V16.1577C0 16.6171 0.373311 17 0.842342 17H6.58559C7.04504 17 7.42793 16.6267 7.42793 16.1577V10.4144H7.41836ZM5.74324 15.3153H1.67511V11.2472H5.74324V15.3153Z",
    fill: "#ADADB4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9904 0.842342C16.9904 0.382883 16.6171 0 16.1481 0H10.4048C9.94538 0 9.57207 0.373311 9.57207 0.842342V6.58559C9.57207 7.04504 9.94538 7.42793 10.4144 7.42793H16.1577C16.6171 7.42793 17 7.05462 17 6.58559V0.842342H16.9904ZM15.3153 5.74324H11.2472V1.67511H15.3153V5.74324Z",
    fill: "#ADADB4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41836 0.842342C7.41836 0.373311 7.04504 0 6.58559 0H0.842342C0.373311 0 0 0.373311 0 0.842342V6.58559C0 7.04504 0.373311 7.42793 0.842342 7.42793H6.58559C7.04504 7.42793 7.42793 7.05462 7.42793 6.58559V0.842342H7.41836ZM5.74324 5.74324H1.67511V1.67511H5.74324V5.74324Z",
    fill: "#ADADB4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9904 10.4144C16.9904 9.95496 16.6171 9.57207 16.1481 9.57207H10.4048C9.94538 9.57207 9.57207 9.94538 9.57207 10.4144V16.1577C9.57207 16.6171 9.94538 17 10.4144 17H16.1577C16.6171 17 17 16.6267 17 16.1577V10.4144H16.9904ZM15.3153 15.3153H11.2472V11.2472H15.3153V15.3153Z",
    fill: "#ADADB4"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "ru",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M496.077,345.043C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043H15.923C5.633,194.69,0,224.686,0,256s5.633,61.31,15.923,89.043L256,367.304L496.077,345.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "de",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M15.923,345.043C52.094,442.527,145.929,512,256,512s203.906-69.473,240.077-166.957L256,322.783L15.923,345.043z"
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M256,0C145.929,0,52.094,69.472,15.923,166.957L256,189.217l240.077-22.261C459.906,69.472,366.071,0,256,0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M15.923,166.957C5.633,194.69,0,224.686,0,256s5.633,61.31,15.923,89.043h480.155C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043H15.923z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "en",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M52.92,100.142c-20.109,26.163-35.272,56.318-44.101,89.077h133.178L52.92,100.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M503.181,189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075,89.076H503.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M8.819,322.784c8.83,32.758,23.993,62.913,44.101,89.075l89.074-89.075L8.819,322.784L8.819,322.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M411.858,52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177L411.858,52.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M100.142,459.079c26.163,20.109,56.318,35.272,89.076,44.102V370.005L100.142,459.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M189.217,8.819c-32.758,8.83-62.913,23.993-89.075,44.101l89.075,89.075V8.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M322.783,503.181c32.758-8.83,62.913-23.993,89.075-44.101l-89.075-89.075V503.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M370.005,322.784l89.075,89.076c20.108-26.162,35.272-56.318,44.101-89.076H370.005z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M509.833,222.609h-220.44h-0.001V2.167C278.461,0.744,267.317,0,256,0c-11.319,0-22.461,0.744-33.391,2.167v220.44v0.001H2.167C0.744,233.539,0,244.683,0,256c0,11.319,0.744,22.461,2.167,33.391h220.44h0.001v220.442C233.539,511.256,244.681,512,256,512c11.317,0,22.461-0.743,33.391-2.167v-220.44v-0.001h220.442C511.256,278.461,512,267.319,512,256C512,244.683,511.256,233.539,509.833,222.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M322.783,322.784L322.783,322.784L437.019,437.02c5.254-5.252,10.266-10.743,15.048-16.435l-97.802-97.802h-31.482V322.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M189.217,322.784h-0.002L74.98,437.019c5.252,5.254,10.743,10.266,16.435,15.048l97.802-97.804V322.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M189.217,189.219v-0.002L74.981,74.98c-5.254,5.252-10.266,10.743-15.048,16.435l97.803,97.803H189.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M322.783,189.219L322.783,189.219L437.02,74.981c-5.252-5.254-10.743-10.266-16.435-15.047l-97.802,97.803V189.219z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "cze",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 3.21875C1.23 5.20875 0 7.95875 0 10.9987C0 14.0387 1.23 16.7888 3.22 18.7788L11 10.9987L3.22 3.21875Z",
    fill: "#11457E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 0C7.95875 0 5.20875 1.23 3.21875 3.22L10.9987 11H21.9988C21.9988 4.92 17.0787 0 10.9987 0Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 18.78C5.20875 20.77 7.95875 22 10.9987 22C17.0787 22 21.9988 17.08 21.9988 11H10.9987L3.21875 18.78Z",
    fill: "#D7141A"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "es",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19098_44447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0017 0C6.34172 0 2.36172 2.91 0.761719 7H21.2417C19.6417 2.91 15.6617 0 11.0017 0Z",
    fill: "#AD1519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.76 7C0.28 8.24 0 9.59 0 11C0 12.41 0.28 13.76 0.76 15H21.24C21.73 13.76 22 12.41 22 11C22 9.59 21.72 8.24 21.24 7H0.76Z",
    fill: "#FABD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0017 22C15.6617 22 19.6417 19.09 21.2417 15H0.761719C2.36172 19.09 6.34172 22 11.0017 22Z",
    fill: "#AD1519"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "vi",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#DA251D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4L6.6725 17L18 8.97235H4L15.3275 17L11 4Z",
    fill: "#FFFF00"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "tr",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E30A17"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.9,
    cy: 11,
    r: 3.85,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.56,
    cy: 11,
    r: 3.08,
    fill: "#E30A17"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "12.65,9.35 13.42,11.72 11.22,10.12 14.08,10.12 11.88,11.72",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "uk",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.925 0 0 4.925 0 11h22C22 4.925 17.075 0 11 0Z",
    fill: "#005BBB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11c0 6.075 4.925 11 11 11s11-4.925 11-11H0Z",
    fill: "#FFD500"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "it",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "it-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#it-clip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 7.33,
    height: 22,
    fill: "#009246"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.33,
    y: 0,
    width: 7.34,
    height: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.67,
    y: 0,
    width: 7.33,
    height: 22,
    fill: "#CE2B37"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "zh",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#DE2910"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "5,4 5.59,5.81 7.5,5.81 5.95,6.94 6.55,8.75 5,7.63 3.45,8.75 4.05,6.94 2.5,5.81 4.41,5.81",
    fill: "#FFDE00"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.5,2.5 9.14,3.24 8.34,3.03 8.84,3.65 8.41,4.33 9.16,4.03 9.58,4.7 9.56,3.91 10.33,3.68 9.56,3.38",
    fill: "#FFDE00"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.5,4 11.14,4.74 10.34,4.53 10.84,5.15 10.41,5.83 11.16,5.53 11.58,6.2 11.56,5.41 12.33,5.18 11.56,4.88",
    fill: "#FFDE00"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.5,6.5 11.14,7.24 10.34,7.03 10.84,7.65 10.41,8.33 11.16,8.03 11.58,8.7 11.56,7.91 12.33,7.68 11.56,7.38",
    fill: "#FFDE00"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.5,8.5 9.14,9.24 8.34,9.03 8.84,9.65 8.41,10.33 9.16,10.03 9.58,10.7 9.56,9.91 10.33,9.68 9.56,9.38",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "ar",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#006C35"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.5h10v1H6z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5h6v0.8H8z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "fa-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa-clip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 7.33,
    fill: "#239F40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.33,
    width: 22,
    height: 7.34,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.67,
    width: 22,
    height: 7.33,
    fill: "#DA0000"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.22,
    height: 18.812,
    viewBox: "0 0 15.22 18.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3662.62,115.909a4.956,4.956,0,1,1,4.96-4.955A4.969,4.969,0,0,1,3662.62,115.909Zm0-8.566a3.612,3.612,0,1,0,3.61,3.611A3.617,3.617,0,0,0,3662.62,107.343Zm6.94,17.478a0.671,0.671,0,0,1-.67-0.672,6.275,6.275,0,0,0-12.55,0,0.67,0.67,0,1,1-1.34,0,7.615,7.615,0,0,1,15.23,0A0.671,0.671,0,0,1,3669.56,124.821Z",
    transform: "translate(-3655 -106)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "company-name",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.84,
    height: 19.969,
    viewBox: "0 0 22.84 19.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3667.24,211.867h-3.11a1.542,1.542,0,0,0-1.54,1.542v2.381a1.542,1.542,0,0,0,1.54,1.541h3.11a1.542,1.542,0,0,0,1.54-1.541v-2.381A1.542,1.542,0,0,0,3667.24,211.867Zm0.42,3.923a0.427,0.427,0,0,1-.42.421h-3.11a0.424,0.424,0,0,1-.42-0.421v-2.381a0.421,0.421,0,0,1,.42-0.421h3.11a0.424,0.424,0,0,1,.42.421v2.381Zm6.19-8.252a0.527,0.527,0,0,0-.07-0.275l-3.4-5.978a0.573,0.573,0,0,0-.49-0.285h-14.93a0.551,0.551,0,0,0-.49.285l-3.4,5.978a0.644,0.644,0,0,0-.07.275,3.283,3.283,0,0,0,1.96,3V220.4a0.56,0.56,0,0,0,.56.56h17.81a0.567,0.567,0,0,0,.56-0.56v-9.789a0.117,0.117,0,0,0-.01-0.06A3.284,3.284,0,0,0,3673.85,207.538Zm-18.57-5.413h14.29l2.65,4.675h-19.59Zm11.98,5.791a2.154,2.154,0,0,1-4.24,0h4.24Zm-5.43,0a2.154,2.154,0,0,1-4.24,0h4.24Zm-9.67,0h4.24A2.154,2.154,0,0,1,3652.16,207.916Zm8.25,11.919h-3.22v-6.048a0.8,0.8,0,0,1,.8-0.8h1.63a0.8,0.8,0,0,1,.8.8v6.048h-0.01Zm10.36,0h-9.24v-6.048a1.915,1.915,0,0,0-1.91-1.92h-1.63a1.92,1.92,0,0,0-1.92,1.92v6.052h-1.99v-9.027c0.07,0,.13,0,0.2,0a3.269,3.269,0,0,1,5.43,0,3.269,3.269,0,0,1,5.43,0,3.269,3.269,0,0,1,5.43,0c0.07,0,.13,0,0.2,0v9.023h0Zm-0.2-10.139a2.155,2.155,0,0,1-2.12-1.775h4.25A2.17,2.17,0,0,1,3670.57,209.7Z",
    transform: "translate(-3651 -201)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "zipcode",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.57,
    height: 24.844,
    viewBox: "0 0 16.57 24.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3662.62,272.836c-0.31,0-.46,0-1.83-2.106-0.5-.767-1.52-2.362-2.66-4.415-1.73-3.114-3.8-7.342-3.8-9.8a8.293,8.293,0,1,1,16.58,0c0,2.456-2.06,6.684-3.8,9.8-1.14,2.054-2.15,3.648-2.65,4.415C3663.08,272.836,3662.94,272.836,3662.62,272.836Zm0-23.642a7.238,7.238,0,0,0-7.13,7.323c0,3.569,5.55,12.7,7.13,14.835,1.58-2.13,7.13-11.264,7.13-14.835A7.238,7.238,0,0,0,3662.62,249.194Zm0,10.567a3.54,3.54,0,1,1,3.45-3.539A3.492,3.492,0,0,1,3662.62,259.761Zm0-5.883a2.345,2.345,0,1,0,2.28,2.344A2.314,2.314,0,0,0,3662.62,253.878Z",
    transform: "translate(-3654.34 -248)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.75,
    height: 20.469,
    viewBox: "0 0 23.75 20.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3670.05,318.273c-2.43,0-6.52-1.124-12.76-6.026-7.73-6.059-5.73-11.125-4.93-12.533,0.77-1.359,1.89-2.132,2.66-1.84a12.508,12.508,0,0,1,4.87,3.763,2.578,2.578,0,0,1,.38,2.748,5.1,5.1,0,0,0-.72,2.121,30.522,30.522,0,0,0,5.93,4.288c1.26,0.655,1.46.493,2.05,0.014a6.022,6.022,0,0,1,1.23-.806h0c1.19-.566,4.08.689,5.29,1.453a2.012,2.012,0,0,1,1.23,1.455,7.771,7.771,0,0,1-.63,2.3c-0.04.13-.09,0.244-0.12,0.337a3.966,3.966,0,0,1-2.74,2.5A6.2,6.2,0,0,1,3670.05,318.273Zm-15.43-19.356a3.6,3.6,0,0,0-1.69,2.251c-0.62,1.848-.78,5.63,5.04,10.2,8,6.273,12.11,6.008,13.51,5.6a2.858,2.858,0,0,0,2-1.8c0.03-.1.08-0.218,0.13-0.354a9.311,9.311,0,0,0,.55-1.852,7.535,7.535,0,0,0-2.86-1.592,3.885,3.885,0,0,0-2.06-.363,4.561,4.561,0,0,0-1,.665c-0.85.684-1.49,1.033-3.28,0.109-2.14-1.113-5.97-3.98-6.41-4.794-0.23-.43-0.2-1.116.7-3.071a1.459,1.459,0,0,0-.21-1.561A11.4,11.4,0,0,0,3654.62,298.917Z",
    transform: "translate(-3651.53 -297.812)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "suitcase",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.4,
    height: 19.875,
    viewBox: "0 0 24.4 19.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3674.1,348.275h-4.8l-1.94-2.615a1.926,1.926,0,0,0-1.54-.783h-5.35a1.93,1.93,0,0,0-1.55.783l-1.94,2.615h-4.8a1.259,1.259,0,0,0-1.25,1.266v13.928a1.259,1.259,0,0,0,1.25,1.266h21.92a1.259,1.259,0,0,0,1.25-1.266V349.541A1.259,1.259,0,0,0,3674.1,348.275Zm-14.28-1.928a0.806,0.806,0,0,1,.65-0.325h5.35a0.8,0.8,0,0,1,.64.325l1.43,1.928h-9.49Zm-7.64,3.073h5.06a0.142,0.142,0,0,0,.02,0h11.76c0.01,0,.02,0,0.03,0h5.05a0.125,0.125,0,0,1,.12.121v6.469h-3.93v-1.167a0.566,0.566,0,0,0-.56-0.572,0.574,0.574,0,0,0-.57.572v1.167h-4.26a1.738,1.738,0,0,0-3.3,0h-4.59v-1.167a0.574,0.574,0,0,0-.57-0.572,0.566,0.566,0,0,0-.56.572v1.167h-3.81v-6.469A0.116,0.116,0,0,1,3652.18,349.42Zm21.92,14.169h-21.92a0.115,0.115,0,0,1-.11-0.12v-6.314h3.81v1.219a0.566,0.566,0,0,0,.56.573,0.574,0.574,0,0,0,.57-0.573v-1.219h4.59a1.733,1.733,0,0,0,3.31,0h4.25v1.219a0.574,0.574,0,0,0,.57.573,0.566,0.566,0,0,0,.56-0.573v-1.219h3.93v6.314A0.124,0.124,0,0,1,3674.1,363.589Z",
    transform: "translate(-3650.94 -344.875)"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "client",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.5,
    height: 24.5,
    viewBox: "0 0 24.5 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3670.02,162.795V161.25a0.381,0.381,0,0,0-.38-0.383h-6.51v-1.162a5.36,5.36,0,1,0-.76,0v1.162h-6.51a0.381,0.381,0,0,0-.38.383v1.545a5.36,5.36,0,1,0,.76,0v-1.163h13.02v1.163A5.36,5.36,0,1,0,3670.02,162.795Zm-11.48,9.074a4.584,4.584,0,0,1-5.36,0V170.82a2.683,2.683,0,0,1,1.36-2.333,2.281,2.281,0,0,0,1.32.419,2.3,2.3,0,0,0,1.32-.419,2.683,2.683,0,0,1,1.36,2.333v1.049Zm-4.21-5.26a1.53,1.53,0,1,1,1.53,1.531A1.528,1.528,0,0,1,3654.33,166.609Zm6.12,1.531a4.546,4.546,0,0,1-1.15,3.035V170.82a3.451,3.451,0,0,0-1.56-2.89,2.3,2.3,0,1,0-3.76,0,3.46,3.46,0,0,0-1.57,2.89v0.355A4.593,4.593,0,1,1,3660.45,168.14Zm-1.15-10.746a4.6,4.6,0,1,1,6.89,0v-0.355a3.449,3.449,0,0,0-1.56-2.89,2.3,2.3,0,1,0-3.76,0,3.459,3.459,0,0,0-1.57,2.89v0.355h0Zm4.98-4.566a1.53,1.53,0,1,1-1.53-1.532A1.535,1.535,0,0,1,3664.28,152.828Zm-4.21,5.26v-1.049a2.683,2.683,0,0,1,1.36-2.333,2.289,2.289,0,0,0,2.64,0,2.683,2.683,0,0,1,1.36,2.333v1.049A4.584,4.584,0,0,1,3660.07,158.088Zm12.25,13.781a4.584,4.584,0,0,1-5.36,0V170.82a2.683,2.683,0,0,1,1.36-2.333,2.289,2.289,0,0,0,2.64,0,2.683,2.683,0,0,1,1.36,2.333v1.049Zm-4.21-5.26a1.53,1.53,0,1,1,1.53,1.531A1.535,1.535,0,0,1,3668.11,166.609Zm4.97,4.566V170.82a3.449,3.449,0,0,0-1.56-2.89,2.3,2.3,0,1,0-3.76,0,3.459,3.459,0,0,0-1.57,2.89v0.355A4.6,4.6,0,1,1,3673.08,171.175Z",
    transform: "translate(-3650.5 -149)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndex);
export default __webpack_public_path__ + "static/media/index.e65c779f9542bd4999a2b0098cf0e2f4.svg";
export { ForwardRef as ReactComponent };